export default __webpack_public_path__ + "static/media/DataSources.5ff85649.md";